import {create} from 'zustand';
import { engagementStats } from '../api_layer/api';
import {DownloadStats} from '../api_layer/api'
import { fetchUser } from '../api_layer/api';
import { filterAgent } from '../api_layer/api';
import { persist } from 'zustand/middleware';
import { isEmpty } from 'lodash';

const useStatsStore = create(
  persist(
    (set) => ({
      statsData: [],
      statsDataDownload: [],
      users: [],
      isLoading: false,
      error: null,
      fetchRepStatsData: async (sd, ed, sd1, ed1) => {
        try {
          set({ isLoading: true, error: null });
          const response = await engagementStats(sd, ed, sd1, ed1);
          set({ statsData: response.data, isLoading: false });
        } catch (error) {
          set({ error: error.message, isLoading: false });
        }
      },
      fetchRepAgentData: async (sd, ed, sd1, ed1, agentId) => {
        try {
          set({ isLoading: true, error: null });
          const response = await filterAgent(sd, ed, sd1, ed1, agentId);
          set({ statsData: response.data, isLoading: false });
        } catch (error) {
          set({ error: error.message, isLoading: false });
        }
      },
      fetchUserData: async () => {
        const state = useStatsStore.getState();
        if(isEmpty(state.users)){
          try {
            set({ isLoading: true, error: null });
            const response = await fetchUser();
            set({ users: response.data, isLoading: false });
          } catch (error) {
            set({ error: error.message, isLoading: false });
          }
        }
      },
      fetchDownloadData: async (sd, ed, sd1, ed1, agentId) => {
        try {
          set({ isLoading: true, error: null });
          const response = await DownloadStats(sd, ed, sd1, ed1, agentId);
          set({ statsDataDownload: response.data, isLoading: false });
        } catch (error) {
          set({ error: error.message, isLoading: false });
        }
      },
    }),
    {
      name: "stats-store",
      partialize: (state) => ({ users: state.users }),
    }
  )
);
export default useStatsStore;
